import { hDeepCopy } from '@/utils/helpers';
import ShButton from '@/components/Helpers/ShButton';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShStarRating from '@/components/Helpers/ShStarRating';
import DepartmentSign from '@/components/Common/DepartmentSign';
import AgentSignature from '@/components/Common/AgentSignature';

// @vue/component
export default {
  name: 'DepartmentAssignedAgentsForm',

  components: {
    ShButton,
    ShUserAvatar,
    ShStarRating,
    DepartmentSign,
    AgentSignature,
  },

  props: {
    department: {
      type: Object,
      default: null,
    },
    agentsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isAnEditingForm: !!this.department,
      editableDepartment: this.department ? hDeepCopy(this.department) : {},
      selectedAgents: [],
    };
  },

  computed: {
    agentsFeedbackList() {
      return this.$store.getters['agents/feedbacksList'];
    },
    isWaitingForFeedback() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'agents/getFeedbackList',
      ]);
    },
    isWaitingForAssigmentOrUnassigment() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'departments/assignAgent',
        'departments/unassignAgent',
        'departments/getList',
      ]);
    },
  },

  created() {
    this.$store.dispatch('agents/getFeedbackList');
    this.selectedAgents = this.isAnEditingForm ? (this.editableDepartment.assigned_agents || '').split(',') : [];
  },

  methods: {
    async handleToogleAgentsInDepartment(agentId) {
      if (!this.isAnEditingForm) {
        this.$emit('update', agentId);
        return;
      }

      const isAssigned = !(this.selectedAgents.includes(String(agentId)));

      const params = {
        department: this.editableDepartment.id,
        agent: agentId,
      };

      if (isAssigned) {
        await this.$store.dispatch('departments/unassignAgent', params);
        this.$store.dispatch('departments/getList');
      } else {
        this.$store.dispatch('departments/assignAgent', params);
      }
    },
  },
};
